/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import authService from './../../../services/auth';
// import profileCompleteness from './../../../components/profileCompleteness/profileCompleteness.vue';
import overviewWidgets from './../../../components/overviewWidgets/overviewWidgets.vue';
import userWidgetsService from './../../../services/widgets';
import TopClients from './../../../components/widgets/topClients/topClients.vue';
import WaitingProcessed from './../../../components/widgets/waitingProcessed/waitingProcessed.vue';
import WaitingDelivered from './../../../components/widgets/waitingDelivered/waitingDelivered.vue';
import OrderReceived from './../../../components/widgets/orderReceived/orderReceived.vue';
import AmountRevenue from './../../../components/widgets/revenue/revenue.vue';
import PopularProduct from './../../../components/widgets/popularProducts/popularProducts.vue';
import soldProduct from './../../../components/widgets/soldProducts/soldProducts.vue';

export default {
  components: {
    // VProfileCompleteness: require('./../../../components/profileCompleteness/profileCompleteness.vue'),
    WaitingProcessed,
    WaitingDelivered,
    OrderReceived,
    TopClients,
    AmountRevenue,
    PopularProduct,
    soldProduct,
  },
  data() {
    return {
      confirmationResent: false,
      confirmationResentError: false,
      loadComponent: false,
      cardItems: [],
      cardCurrentOrder: [],
    };
  },

  created() {
    if (!this.account.organizationName) {
      this.$router.push('/profile/account');
    }

    if ((this.account.firstName && this.account.lastName) || (this.account.organizationName)) {
      this.loadComponent = true;
    }

    if (
      (!this.account.organizationName || this.account.organizationName === '') &&
      this.account.organizationMembers == 0 &&
      ((!this.account.firstName || this.account.firstName === '') || (!this.account.lastName || this.account.lastName === ''))
    ) {
      this.activateModal();
    }

    this.initializeWidgets();
  },

  computed: {
    ...mapGetters({
      account: 'account',
      widgets: 'widgets',
      availableWidgets: 'availableWidgets',
    }),
  },

  watch: {
    widgets(widgets) {
      if (widgets.items !== 'no_widget' && widgets.items.length > 0) {
        this.cardItems = this.readSerialize(widgets.items);
        const self = this;
        this.cardItems.forEach((item, i) => { self.cardCurrentOrder[i] = i; });
      }
    },
  },

  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_INNERSIDEBAR',
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Activates the modal
     */
    activateModal() {
      this.setModalContent(() => profileCompleteness);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /*
     * Assigns the modal content and triggers the modal
     * Actually we should assign the modal content on page created
     * and toggle modal on separate method.
     */
    // onQuickFormClick() {
    //   this.setModalContent(() => profileCompleteness);
    //   this.setModalCloseOnClick(false);
    //   this.setModalShowClose(false);
    //   this.setModalCloseOnPressEscape(false);
    //   this.toggleModal(true);
    // },

    /**
     * This method will be called when saving the form.
     */
    resendConfirmation() {
      Promise.resolve(authService.resendConfirmation())
        .then(() => {
          this.confirmationResent = true;
        }).catch(() => {
          this.confirmationResentError = true;
        });
    },

    /**
     * Widgets manipulation
     */
    widgetsRemove(index) {
      this.cardItems.splice(index, 1);
      this.saveWidgets(this.cardItems);
    },

    widgetsAdd() {
      this.overviewWidgetsModal();
    },

    overviewWidgetsModal() {
      this.setModalContent(() => overviewWidgets);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    initializeWidgets() {
      Promise.all([
        userWidgetsService.fetchAvailableWidgets(),
        userWidgetsService.fetchUserWidgets(),
      ]).then(() => {
        if (this.widgets.items !== 'no_widget' && this.widgets.items.length > 0) {
          this.cardItems = this.readSerialize(this.widgets.items);
          const self = this;
          this.cardItems.forEach((item, i) => {
            self.cardCurrentOrder[i] = i;
            self.availableWidgets.items.avialableWidgetsData.forEach((item2, n) => {
              if (item2.key === item.key) {
                item.title = item2.title; item.sub = item2.subtitle; item.desc = item2.desc;
              }
            });
          });
        }
      });
    },

    saveWidgets(value) {
      userWidgetsService.updateUserWidgets(value).then(() => {});
    },

    readSerialize(value) {
      let newJson = value.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
      newJson = newJson.replace(/'/g, '"');
      return JSON.parse(newJson);
    },

    onChangePos(to, from) {
      this.insertAndShift(this.cardItems, from, to);
      this.saveWidgets(this.cardItems);
      this.cardCurrentOrder[from] = from;
    },

    insertAndShift(arr, from, to) {
      const cutOut = arr.splice(from, 1)[0];
      arr.splice(to, 0, cutOut);
    },
  },

};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/dashboard/dashboard.js